<template>
  <el-tree ref="roletree" :data="roleList" :props="defaultRoleProps" :filter-node-method="filterNode"
    :expand-on-click-node="false" node-key="roleID" highlight-current default-expand-all class="role-auth-tree"
    @node-click="systemTableClick">
    <template #default="{ data }">
      <div class="tree-content" @mouseenter="mouseenter(data)" @mouseleave="mouseleave(data)">
        <div class="tree-content-header">
          <img v-if="roleType == 0" :src="role_png" style="margin-right: 6px" alt="图片" />
          <img v-if="roleType != 0 && !data.$isOperation && data.defaultFlag" :src="role_png" style="margin-right: 6px" alt="图片" />
          <img v-if="roleType != 0 && data.$isOperation" :src="major_png" style="margin-right: 6px" alt="图片" />
          <img v-if="roleType != 0 && !data.$isOperation && !data.defaultFlag" :src="customRole_png" style="margin-right: 6px" alt="图片" />
          <span :title="data.roleName" class="textAll">{{ data.roleName }}</span>
        </div>
        <div v-if="!data.defaultFlag" class="operations_0">
          <i v-show="data.show && data.$isOperation && editSpecConfig" class="el-icon-edit-outline"
            @click="updateMajorHandler(data)">
          </i>
          <i v-show="data.show && !data.$isOperation && editRoleConfig" class="el-icon-edit-outline"
            @click="updateRoleHandler(data)">
          </i>
          <i v-show="data.show && data.$isOperation && deleSpecConfig" class="el-icon-delete"
            @click="deleteRoleHandler(data)"></i>
          <i v-show="data.show && !data.$isOperation && deleRoleConfig" class="el-icon-delete"
            @click="deleteRoleHandler(data)"></i>
        </div>
        <div v-show="data.show" class="operations">
          <i v-if="data.upMove == 1" class="el-icon-my-sysUp" @click.stop="rolePermissionMove(data, 1)"></i>
          <i v-if="data.downMove == 1" class="el-icon-my-sysDown" @click.stop="rolePermissionMove(data, 2)"></i>
        </div>
      </div>
    </template>
  </el-tree>
</template>

<script>
import priviService from "@/CommonDP/service/privi-service";
import { mapState } from "vuex";
import { disablePrompt, checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  props: {
    roleType: {
      type: Number,
      default: 0
    },
    curOption: {
      type: Object,
      default: () => ({
        roleID: "",
        roleName: ""
      })
    }
  },
  data() {
    return {
      roleList: [], // 角色列表
      defaultRoleProps: {
        children: "childList",
        label: "roleName"
      },
      role_png: require("@/CommonDP/assets/settings/systemRole.png"),
      major_png: require("@/CommonDP/assets/settings/major.png"),
      customRole_png: require("@/CommonDP/assets/settings/customRole.png"),
      editRoleConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_EDIT_ROLE),
      deleRoleConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_DELE_ROLE),
      deleSpecConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_DELE_SPEC),
      editSpecConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_EDIT_SPEC),
      systemAddOption: {
        roleID: "",
        $isOperation: "",
        roleName: "",
        pid: "",
        id: ""
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getRoleList();
  },
  methods: {
    // 获取角色 并设置默认选中且刷新浏览器人保存
    async getRoleList(statusCode = this.roleType) {
      const roleID = this.curOption.roleID || this.systemAddOption.roleID;
      const roleName = this.curOption.roleName || this.systemAddOption.roleName;
      if (statusCode == 0) {
        priviService.querySysRoleList(this.enterpriseId).then(({ data }) => {
          this.$emit('setLoading');
          this.roleList = data.map((item, index) => {
            item.childList = [];
            item.pid = "0";
            item.upMove = 1;
            item.downMove = 1;
            if (index === 0) item.upMove = 0;
            if (index === data.length - 1) item.downMove = 0;
            return item;
          });
          if (roleID) {
            this.$emit('modellist', roleID);
            const data = {
              roleID,
              roleName
            };
            this.$emit('queryPreson', data);
            this.$nextTick(() => {
              if (this.$refs.roletree) {
                this.$refs.roletree.setCurrentKey(roleID);
              }
            });
            this.systemAddOption.roleID = roleID;
            this.systemAddOption.roleName = roleName;
          } else {
            if (this.roleList && this.roleList.length > 0) {
              this.pageIndex = 1;
              const data = {
                roleID: this.roleList[0].roleID,
                roleName: this.roleList[0].roleName
              };
              this.$emit('queryPreson', data);
              this.$emit('modellist', this.roleList[0].roleID);
              this.$nextTick(() => {
                if (this.$refs.roletree) {
                  this.$refs.roletree.setCurrentKey(this.roleList[0].roleID);
                }
              });
              this.systemAddOption.roleID = this.roleList[0].roleID;
              this.systemAddOption.roleName = this.roleList[0].roleName;
            }
          }
        });
      } else if (statusCode == 1) {
        priviService.getPrjRoleTree(this.enterpriseId, 0).then(({ data }) => {
          this.$emit('setLoading');
          this.roleList = data.map(item => {
            item.$isOperation = 1;
            item.pid = "0";
            return item;
          });
          if (roleID) {
            this.$emit('modellist', roleID);
            this.$nextTick(() => {
              if (this.$refs.roletree) {
                this.$refs.roletree.setCurrentKey(roleID);
              }
            });
            this.systemAddOption.roleID = roleID;
            this.systemAddOption.roleName = roleName;
          } else {
            if (this.roleList && this.roleList.length > 0) {
              this.systemTableClick(this.roleList[0].childList[0]);
              this.$nextTick(() => {
                if (this.$refs.roletree) {
                  this.$refs.roletree.setCurrentKey(this.roleList[0].childList[0].roleID);
                }
              });
              this.systemAddOption.roleID = this.roleList[0].childList[0].roleID;
              this.systemAddOption.roleName = this.roleList[0].childList[0].roleName;
            }
          }
        });
      }
      this.$emit('setSystemAddOption', this.systemAddOption);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    },
    systemTableClick(row) {
      this.systemAddOption.$isOperation = row.$isOperation;
      this.systemAddOption.roleName = row.roleName;
      this.initEmptyModule();
      this.systemAddOption.id = row.id;
      this.systemAddOption.roleID = row.roleID;
      this.systemAddOption.pid = row.pid;
      const statusCode = parseInt(this.roleType);
      if (row.roleID && row.pid && !this.systemAddOption.$isOperation) {
        if (statusCode === 0) {
          this.$emit('queryPreson', row);
        }
        const data = {
          roleType: this.roleType,
          roleID: row.roleID,
          roleName: row.roleName
        };
        this.$emit('setRoleTreeData', data);
        this.$emit('modellist', row.roleID, this.roleType);
      }
    },
    // 初始化 模块树 -> 空
    initEmptyModule() {
      this.$emit('empty');
      this.systemAddOption.roleID = "";
    },
    mouseenter(data) {
      this.$set(data, "show", true);
    },
    mouseleave(data) {
      this.$set(data, "show", false);
    },
    updateMajorHandler({ roleID, roleName, id }) {
      const a = disablePrompt();
      if (a) {
        const { $prompt } = this;
        $prompt("请输入专业名称", "编辑专业名称", {
          inputPlaceholder: "编辑专业名称",
          inputValue: roleName,
          inputErrorMessage: "请输入除空格外的15文字以内的专业名称",
          inputPattern: /^\S{1,15}$/,
          beforeClose: (action, { inputValue }, done) => {
            if (action === "cancel") done();
            else {
              const { updateRole, enterpriseId } = this;
              const form = {
                roleName: inputValue,
                roleId: roleID,
                enterpriseId
              };
              const majorForm = { specName: inputValue, id, enterpriseId };
              updateRole(form, majorForm).then(() => {
                done();
              });
            }
          }
        });
      }
    },
    updateRoleHandler({ roleID, roleName, id }) {
      const a = disablePrompt();
      if (a) {
        const { $prompt } = this;
        $prompt("请输入角色名称", "编辑角色名称", {
          inputPlaceholder: "编辑角色名称",
          inputValue: roleName,
          inputErrorMessage: "请输入除空格外的15文字以内的角色名称",
          inputPattern: /^\S{1,15}$/,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          beforeClose: (action, { inputValue }, done) => {
            if (action === "cancel") done();
            else {
              const { updateRole, enterpriseId } = this;
              const form = {
                roleName: inputValue,
                roleId: roleID,
                enterpriseId
              };
              const majorForm = { specName: inputValue, id, enterpriseId };
              updateRole(form, majorForm).then(() => {
                done();
              });
            }
          }
        });
      }
    },
    updateRole(form, majorForm) {
      const {
        systemAddOption: { $isOperation },
        roleType
      } = this;
      const type = parseInt(roleType);
      if (type === 0) {
        return priviService.updateSysRole(form).then(() => {
          this.$message({ type: "success", message: "角色修改成功" });
          this.getRoleList();
        });
      } else if (type === 1) {
        if ($isOperation) {
          return priviService.updateEnterpriseSpec(majorForm).then(() => {
            this.$message({ type: "success", message: "专业修改成功" });
            this.getRoleList();
          });
        } else {
          form.specId = this.systemAddOption.pid;
          return priviService.updatePrjRole(form).then(() => {
            this.$message({ type: "success", message: "角色修改成功" });
            this.getRoleList();
          });
        }
      }
    },
    // 删除 角色
    deleteRoleHandler(row) {
      const a = disablePrompt();
      if (a) {
        const { $confirm, $message, getRoleList, roleType, enterpriseId } = this;
        const { roleID, roleName, $isOperation, id } = row;
        const statusCode = parseInt(this.roleType);
        if (statusCode === 0) {
          $confirm(`确定删除系统角色 ${roleName}?`, "警告", {
            type: "warning"
          })
            .then(() => priviService.delSysRole(roleID))
            .then(() => {
              console.log(this.roleList);
              this.systemAddOption.roleID = this.roleList[0].roleID;
              this.systemAddOption.roleName = this.roleList[0].roleName;
              $message({ type: "success", message: "删除角色成功" });
            })
            .then(() => {
              getRoleList();
            });
        } else if (statusCode === 1) {
          if ($isOperation) {
            $confirm(`确定删除该 ${roleName}专业吗?`, "警告", {
              type: "warning"
            })
              .then(() => priviService.delEnterpriseSpec(id, enterpriseId))
              .then(() => {
                this.systemAddOption.roleID = this.roleList[0].roleID;
                this.systemAddOption.roleName = this.roleList[0].roleName;
                $message({ type: "success", message: "删除专业成功" });
              })
              .then(() => {
                getRoleList();
              });
          } else {
            $confirm(`确定删除项目角色 ${roleName}吗?`, "警告", {
              type: "warning"
            })
              .then(() => priviService.delPrjRole(roleID))
              .then(() => {
                this.systemAddOption.roleID = this.roleList[0].roleID;
                this.systemAddOption.roleName = this.roleList[0].roleName;
                $message({ type: "success", message: "删除角色成功" });
              })
              .then(() => {
                getRoleList();
              });
          }
        }
      }
    },
    // 系统角色上移下移
    async rolePermissionMove(data, moveType) {
      const roleId = data.roleID;
      const params = { roleId, moveType };
      await priviService.rolePermissionMove(params);
      this.getRoleList();
    },
    filterText(val) {
      this.$refs.roletree.filter(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.operations_0 {
  width: 42px;
  height: 20px;
  padding: 2px;
  font-size: 16px;
  white-space: nowrap;
  display: flex;
  align-items: center;

  i {
    margin-left: 3px;
    color: #7f89ba;
  }

  i:hover {
    color: #4777e7;
  }
}
.operations {
  width: 42px;
  height: 20px;
  padding: 2px;
  font-size: 16px;
  white-space: nowrap;
  display: flex;
  align-items: center;

  i {
    margin-left: 3px;
    color: #7f89ba;
  }

  i:hover {
    color: #4777e7;
  }
}
.el-icon-my-sysUp {
  background: url("~@/CommonDP/assets/settings/sysUser_up.png") center no-repeat;
  width: 16px;
  height: 16px;
}

.el-icon-my-sysUp:before {
  content: "替";
  font-size: 16px;
  visibility: hidden;
}
.el-icon-my-sysDown {
  background: url("~@/CommonDP/assets/settings/sysUser_down.png") center no-repeat;
  width: 16px;
  height: 16px;
}

.el-icon-my-sysDown:before {
  content: "替";
  font-size: 16px;
  visibility: hidden;
}
.role-auth-table {
  .el-tree-node__content {
    line-height: 20px;
    padding: 4px;
  }
}
</style>
<style lang="scss" scoped src="../index.scss" />
